import { render, staticRenderFns } from "./Taskbar.vue?vue&type=template&id=54325df8&scoped=true&"
import script from "./Taskbar.vue?vue&type=script&lang=js&"
export * from "./Taskbar.vue?vue&type=script&lang=js&"
import style0 from "./Taskbar.vue?vue&type=style&index=0&id=54325df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54325df8",
  null
  
)

export default component.exports